const LINE_BREAK_TAGS = /<br\s*\/?>|<\/(?:p|div|li|h[1-6]|blockquote)\s*>/gi

export function htmlToPlainText(value: string | null | undefined): string {
  if (!value) {
    return ''
  }
  const doc = new DOMParser().parseFromString(value.replace(LINE_BREAK_TAGS, '\n'), 'text/html')
  return (doc.body.textContent ?? '').trim()
}
